import { render } from "./editDealerGroupForm.vue?vue&type=template&id=4b849be4&scoped=true"
import script from "./editDealerGroupForm.vue?vue&type=script&lang=js"
export * from "./editDealerGroupForm.vue?vue&type=script&lang=js"

import "./editDealerGroupForm.vue?vue&type=style&index=0&id=4b849be4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b849be4"]])

export default __exports__